import { MapTo } from '@adobe/aem-react-editable-components';
import Tabs, { TabsEditConfig } from './Tabs';

export default MapTo('cob-corp-acquisition/components/creditonebank/tabs')(Tabs, TabsEditConfig);